"use client";

import { createContext, useContext } from "react";
import type { CypherpunkTrackerPayload } from "@/types/cypherpunkTrackerData";

export type CypherpunkTrackerState = {
  data: CypherpunkTrackerPayload | null;
  loading: boolean;
  error: string | null;
};

const CypherpunkTrackerContext = createContext<CypherpunkTrackerState | null>(null);

export function CypherpunkTrackerProvider({
  value,
  children,
}: {
  value: CypherpunkTrackerState;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <CypherpunkTrackerContext.Provider value={value}>{children}</CypherpunkTrackerContext.Provider>
  );
}

export function useCypherpunkTracker(): CypherpunkTrackerState {
  const ctx = useContext(CypherpunkTrackerContext);
  if (!ctx) {
    throw new Error("useCypherpunkTracker must be used within CypherpunkTrackerProvider");
  }
  return ctx;
}
